import { useState } from 'react';
import { qryCopilotValueApi, getCopilotValueByTaskIdApi } from '@/api/copilot';
import { useAuth } from '@/contexts/AuthContext';
import { type TabValue } from './useTabControl';
import useUserStore from '@/stores/userStore';
import {
  CopilotValue1,
  CopilotValue2,
  CopilotValue22,
  CopilotValue3
} from '@/stores/types/copilotValue';
import useCopilotValueStore from '@/stores/copilotValueStore';
import { usePollingApi } from '@/hooks/usePollingApi';
import { EXTERNAL_USER_ID } from '@/config/env';

export const useDiagnosisData = () => {
  const { externalUserId, followUserId } = useAuth();
  const [loading, setLoading] = useState<boolean>(false);
  const { taskId, updateTaskId, updateUserInfo } = useUserStore();
  const { updateCopilotValue1, updateCopilotValue2, updateCopilotValue3, updateCopilotValue22 } =
    useCopilotValueStore();
  const reqTypes = [1, 2, 3] as const;

  const getCopilotValueByTaskId = async (taskIdParam?: string | null): Promise<void> => {
    try {
      const pUseAll = reqTypes.map(reqType =>
        getCopilotValueByTaskIdApi({
          externalUserId,
          reqType,
          taskId: taskIdParam || taskId,
          followUserId
        })
      );

      const results = await Promise.allSettled(pUseAll);

      results.forEach((result, index) => {
        if (result.status === 'fulfilled') {
          if (index === 0) {
            const resultData = result.value as CopilotValue1;
            if (
              resultData &&
              typeof resultData === 'object' &&
              Object.keys(resultData).length > 0
            ) {
              updateCopilotValue1(resultData);
              const userInfoData = {
                user_tags: (resultData.user_tags || '').split('、'),
                profile_summary: resultData.profile_summary
              };
              updateUserInfo(userInfoData);
            }
          }
          if (index === 1) {
            const resultData = result.value as CopilotValue2;
            if (
              resultData &&
              typeof resultData === 'object' &&
              Object.keys(resultData).length > 0
            ) {
              updateCopilotValue2(resultData);
              if (Array.isArray(resultData.customerInfo) && resultData.customerInfo.length > 0) {
                const customerInfo = resultData.customerInfo[0];
                updateUserInfo({
                  customer_name: customerInfo.customer_name,
                  risk_level: customerInfo.risk_level,
                  investment_experience: customerInfo.investment_experience,
                  total_assets: customerInfo.total_assets
                });
              }
            }
          }
          if (index === 2) {
            const resultData = result.value as CopilotValue3;
            if (
              resultData &&
              typeof resultData === 'object' &&
              Object.keys(resultData).length > 0
            ) {
              updateCopilotValue3(resultData);
            }
          }
        }
      });
    } catch (error) {
      console.error('获取Copilot数据失败:', error);
      throw error;
    }
  };

  const polling22 = usePollingApi(
    ({ taskId: tId }) => {
      return getCopilotValueByTaskIdApi({
        externalUserId: externalUserId || EXTERNAL_USER_ID,
        reqType: 22,
        taskId: tId,
        followUserId
      });
    },
    response => response?.status === 'false',
    {
      interval: 1000,
      onSuccess: (data: CopilotValue22) => {
        updateCopilotValue22({
          ...data,
          loading: false
        });
      },
      onError: error => {
        console.error('轮询失败 (reqType: 3):', error);
        updateCopilotValue22({
          loading: false
        });
      }
    }
  );

  const handleQueryCopilotValue = async (tab: TabValue) => {
    if (taskId) {
      if (tab === 'servicesRecommendations') {
        updateCopilotValue22({
          loading: true
        });
        polling22.startPolling({ taskId });
      } else {
        await getCopilotValueByTaskId();
      }
    } else {
      const response = await qryCopilotValueApi({
        externalUserId,
        reqType: 0,
        followUserId
      });
      if (response) {
        updateTaskId(response);
        if (tab === 'servicesRecommendations') {
          polling22.startPolling({ taskId: response });
        } else {
          await getCopilotValueByTaskId(response);
        }
      }
    }
  };

  const fetchCopilotData = async (tab: TabValue) => {
    console.log(tab, 'dldldldl');
    try {
      setLoading(true);

      await handleQueryCopilotValue(tab);

      // if (taskId) {
      //   await getCopilotValueByTaskId();
      // } else {
      //   const response = await qryCopilotValueApi({
      //     externalUserId,
      //     reqType: 0,
      //     followUserId
      //   });
      //   if (response) {
      //     updateTaskId(response);
      //     await getCopilotValueByTaskId(response);
      //   }
      // }
    } catch (error) {
      console.error('获取Copilot数据失败:', error);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    refresh: fetchCopilotData,
    handleQueryCopilotValue,
    polling22
  };
};
